<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    width="800px"
    top="3%"
    :close-on-click-modal="false"
  >
    <div v-loading="loading" class="address">
      <div class="address_book">
        <div class="address_book_left">
          <div class="address_book_left_search">
            <template v-if="type.includes(0) && type.length === 1">
              <el-input
                v-model="search"
                clearable
                placeholder="请输入部门名称"
                class="input-with-select"
                size="small"
                @keyup.enter.native="handleSearch"
                @clear="handleSearch"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleSearch"
                />
              </el-input>
            </template>

            <template v-else>
              <el-input
                v-model="search"
                clearable
                placeholder="请输入"
                class="input-with-select"
                size="small"
                @keyup.enter.native="handleSearch"
                @clear="handleSearch"
              >
                <el-select
                  slot="prepend"
                  v-model="select"
                  class="w-100"
                  placeholder="请选择"
                >
                  <el-option label="用户姓名" value="nickName" />
                  <el-option label="手机号码" value="phone" />
                  <!-- <el-option label="英文名称" value="userName" /> -->
                </el-select>
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="handleSearch"
                />
              </el-input>
            </template>
          </div>

          <!-- 导航面包屑 -->
          <div class="crumbs">
            <span
              v-for="(item, index) in crumbs"
              :key="`crumbs_${item.deptId}`"
              class="crumbsView"
            >
              <span
                :class="index === crumbs.length - 1 ? 'colorBlue' : ''"
                @click="changeCrumbs(item, index)"
                >{{ item.name }}
              </span>
              <span v-if="index !== crumbs.length - 1" class="m-r-5">/</span>
            </span>
          </div>

          <!-- 部门列表 -->
          <div
            v-infinite-scroll="load"
            class="addressBooks"
            style="overflow: auto"
            infinite-scroll-disabled="disabled"
          >
            <div
              v-for="item in depts"
              :key="`dept_${item.deptId}`"
              class="addressBooksBox"
              @click="changeDept(item)"
            >
              <template
                v-if="disabledDept.includes(item.deptId) || item.status === 1"
              >
                <span
                  v-if="type.includes(0)"
                  :class="multiple ? 'checkBox' : 'checkBoxRadio'"
                  class="disabled"
                >
                  <svg-icon
                    v-if="checkDeptIds.includes(item.deptId)"
                    icon-class="gou"
                  />
                </span>
              </template>
              <template v-else>
                <span
                  v-if="type.includes(0)"
                  :class="multiple ? 'checkBox' : 'checkBoxRadio'"
                >
                  <svg-icon
                    v-if="checkDeptIds.includes(item.deptId)"
                    icon-class="gou"
                  />
                </span>
              </template>
              <span class="checkName">{{ item.name }}</span>
              <span class="next" @click.stop="goToNext(item)">下级</span>
            </div>

            <div class="userAddressBooks">
              <div
                v-for="(item, index) in users"
                :key="`user_${item.userId}_${index}`"
              >
                <div class="addressBooksBox">
                  <span
                    v-if="type.includes(1)"
                    :class="[
                      multiple ? 'checkBox' : 'checkBoxRadio',
                      { disabled: disabledUser.includes(item.userId) }
                    ]"
                    @click="changeUser(item)"
                  >
                    <svg-icon
                      v-if="checkUserIds.includes(item.userId)"
                      icon-class="gou"
                    />
                  </span>
                  <div class="checkName" @click="changeUser(item)">
                    <AppAvatar
                      :avatar="item.avatar"
                      :name="item.nickName"
                      :width="34"
                      class="m-r-5"
                      :no-name="true"
                    />
                    <div class="userInfo">
                      <div class="checkName">
                        <span class="userName">{{
                          item.nickName || item.name
                        }}</span>
                        <el-tag
                          v-if="item.status === 1"
                          class="m-l-10"
                          type="danger"
                          size="mini"
                          >离职</el-tag
                        >
                      </div>
                      <div class="userInfoDetail">
                        <div class="userInfoDetailForm flex" @click.stop>
                          <span class="userInfoDetailFormLabel">手机号：</span>
                          <span class="userInfoDetailFormValue">
                            <tablePhoneItem
                              v-model="item.phoneNumber"
                              :row-data="{ uid: item.userId }"
                              type="system"
                            />
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <el-popover placement="right" width="300" trigger="hover">
                    <div class="userDetailCard">
                      <div class="userDetailCard_header">
                        <AppAvatar
                          :avatar="item.avatar"
                          :name="item.nickName"
                          :width="34"
                          class="m-r-5"
                          :no-name="true"
                        />
                        <div class="m-l-10">
                          <div>{{ item.nickName || item.name }}</div>
                          <div>
                            <span>uid:{{ item.userId }}</span>
                            <el-tag
                              v-if="item.status === 1"
                              type="danger"
                              class="m-l-10"
                              size="mini"
                              >离职</el-tag
                            >
                            <el-tag v-else class="m-l-10" size="mini"
                              >在职</el-tag
                            >
                          </div>
                        </div>
                      </div>
                      <div class="userDetailCardForm">
                        <span class="userDetailCardLabel">所属部门:</span>
                        <span class="userDetailCardValue">{{
                          item.deptName
                        }}</span>
                      </div>
                      <div class="userDetailCardForm">
                        <span class="userDetailCardLabel">手机号码:</span>
                        <span class="userDetailCardValue">{{
                          item.phoneNumber
                        }}</span>
                      </div>
                      <div class="userDetailCardForm">
                        <span class="userDetailCardLabel">角色:</span>
                        <span class="userDetailCardValue">
                          <el-tag
                            v-for="(tag, i) in item.roleVoList"
                            :key="i"
                            size="mini"
                            >{{ tag.roleName }}</el-tag
                          >
                        </span>
                      </div>
                    </div>
                    <span slot="reference" class="next">详情</span>
                  </el-popover>
                </div>

                <div
                  v-if="item.qwRelationList && item.qwRelationList.length"
                  class="qw-relations"
                >
                  <div
                    v-for="(sub, sIdx) in item.qwRelationList"
                    :key="`sub_${item.userId}_${sub.qwUserId}_${sIdx}`"
                    :class="[
                      'qw-relation-card',
                      { 'qw-relation-card--active': isQwSubChecked(item, sub) }
                    ]"
                    @click.stop="handleToggleQwSub(item, sub)"
                  >
                    <span
                      :class="[
                        multiple ? 'checkBox' : 'checkBoxRadio',
                        {
                          disabled:
                            disabledUser.includes(getQwSubId(item, sub)) ||
                            disabledUser.includes(item.userId)
                        }
                      ]"
                      @click.stop="handleToggleQwSub(item, sub)"
                    >
                      <svg-icon v-if="isQwSubChecked(item, sub)" icon-class="gou" />
                    </span>
                    <AppAvatar
                      :avatar="sub.avatar || ''"
                      :name="sub.nickName"
                      :width="32"
                      class="m-r-5"
                      :no-name="true"
                    />
                    <div class="qw-relation-info">
                      <div class="qw-relation-name">
                        {{ sub.nickName || sub.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div v-if="depts.length === 0 && users.length === 0" class="noData">
              暂无数据
            </div>
          </div>
        </div>
        <div class="address_book_right">
          <!-- 人员列表：树状按主账号分组 -->
          <template v-if="type.includes(1)">
            <div
              v-for="(group, gIdx) in groupedCheckUser"
              :key="`group_${group.mainKey}_${gIdx}`"
              class="check-group"
            >
              <div class="check-group__main checkList">
                <span class="check-group__main-label">{{ group.mainName }}</span>
                <i class="el-icon-close" @click="delMainGroup(group)" />
              </div>
              <div v-if="group.items.length > 0">
                <div
                  v-for="(sub, sIdx) in group.items"
                  :key="`sub_${sub.userId}_${sIdx}`"
                  v-if="hasQwRelation(sub._main)"
                  class="check-group__sub checkList"
                >
                  <span class="check-group__sub-label">
                    <span class="qw-prefix">企业微信</span>
                    <span class="qw-name">{{
                      sub._qwNickName || sub.nickName || sub.name
                    }}</span>
                  </span>
                  <i
                    class="el-icon-close"
                    @click="delUserCheck(sub, getCheckUserIndex(sub))"
                  />
                </div>
              </div>
            </div>
            <div
              v-if="!groupedCheckUser.length"
              class="noData right-empty"
              style="border:none;height:auto;line-height:40px;color:#909399;"
            >
              暂无选择
            </div>
          </template>

          <!-- 部门列表 -->
          <template v-if="type.includes(0)">
            <div
              v-for="(item, index) in checkDept"
              :key="`${item.id}_${index}`"
              class="checkList"
            >
              <span>{{ item.name }}</span>
              <i class="el-icon-close" @click="delDeptCheck(item, index)" />
            </div>
          </template>
        </div>
      </div>
      <div class="address_footer">
        <div>
          <template v-if="ifCanCheck()">
            <template v-if="users.length > 0">
              <el-checkbox
                :value="checked"
                :indeterminate="isIndeterminate"
                @change="handleCheckAllChange"
                >全选</el-checkbox
              >
              <span>(已选{{ checkUserIds.length }}项)</span>
            </template>
          </template>
          <template v-if="isShowSelect">
            <div class="inherit_select">
              <div>企业微信</div>
              <m-select
                v-model="qwInheritType"
                dict-key="INHERIT_STATUS"
                style="width: 200px"
                size="mini"
              />
            </div>
          </template>
        </div>
        <div class="footer_btn">
          <el-button type="primary" size="small" @click="sure()"
            >确 定</el-button
          >
          <el-button size="small" @click="cancel()">取 消</el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import {
  deptTree,
  deptTreeNew,
  userNoPageNew,
  userNoPage
} from '@/api/addressBookApi'
import AppAvatar from '@/components/AppAvatar/AppAvatar.vue'
import tablePhoneItem from '@/components/AppTemplate/tablePhoneItem'
export default {
  name: 'AddressBook',
  components: {
    AppAvatar,
    tablePhoneItem
  },
  props: {
    title: {
      type: String,
      default: '选择'
    },
    defultCheck: {
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    success: {
      type: Function,
      default: () => {}
    },
    isShowSelect: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    type: {
      type: Array,
      default: () => [0, 1]
    },
    params: {
      type: Object,
      default: () => {}
    },
    disabledDept: {
      type: Array,
      default: () => []
    },
    disabledUser: {
      type: Array,
      default: () => []
    },
    taskObjective:{
      type:Boolean,
      default:false
    },
    maxlength: {
      type: Number,
      default: 0
    },
    minlength: {
      type: Number,
      default: 0
    },
    defaultCheckUser: {
      type: Array,
      default: () => []
    },
    defaultCheckDept: {
      type: Array,
      default: () => []
    },
    ifAll: {
      type: Boolean,
      default: false
    },
    searchType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      qwInheritType: 1,
      total: 0,
      pageSize: 10,
      currentPage: 1,
      search: '',
      select: 'nickName',
      props: {
        label: 'corpName',
        children: 'children',
        isLeaf: 'leaf'
      },
      checkDeptIds: [],
      checkDept: [],
      checkUserIds: [],
      checkUser: [],
      depts: [],
      users: [],
      crumbs: [{ id: '-1', name: '通讯录' }],
      parentId: '0',
      loading: false,
      tenantId: '',
      rootTenantId: '',
      rootParentId: '0',
      noMore: false,
      checked: false,
      isIndeterminate: false,
      isSearch: false
    }
  },
  computed: {
    disabled() {
      return this.loading || this.noMore
    },
    groupedCheckUser() {
      const groupMap = new Map()
      const ensureGroup = (mainKey, mainName, mainRow = null) => {
        if (!groupMap.has(mainKey)) {
          groupMap.set(mainKey, {
            mainKey,
            mainName: mainName || '未命名主账号',
            main: mainRow,
            items: [],
            _itemKeys: new Set()
          })
        } else if (mainRow) {
          const g = groupMap.get(mainKey)
          g.main = mainRow
          if (mainName && (!g.mainName || g.mainName === '未命名主账号')) {
            g.mainName = mainName
          }
        } else if (mainName) {
          const g = groupMap.get(mainKey)
          if (!g.mainName || g.mainName === '未命名主账号') {
            g.mainName = mainName
          }
        }
        return groupMap.get(mainKey)
      }
      this.checkUser.forEach(item => {
        const info = this._normalizeCheckItem(item)
        if (info.isQwSub) {
          const g = ensureGroup(
            info.mainKey,
            info.mainRow
              ? info.mainRow.nickName || info.mainRow.name
              : item._mainName,
            info.mainRow
          )
          const row = info.normalizedRow
          let dedupKey = String(row.userId)
          if (info.mainRow && row._sub) {
            dedupKey = this.getQwSubId(info.mainRow, row._sub)
          } else if (info.mainRow && (row.qwUserId || row._qwNickName)) {
            dedupKey = `qw|${info.mainKey}|${row.qwUserId || row._qwNickName || ''}`
          }
          if (!g._itemKeys.has(dedupKey)) {
            g._itemKeys.add(dedupKey)
            g.items.push(row)
          }
        } else {
          const mainKey = String(item.userId)
          ensureGroup(
            mainKey,
            item.nickName || item.name || item._mainName,
            item
          )
        }
      })
      const result = Array.from(groupMap.values())
      result.forEach(g => delete g._itemKeys)
      return result
    }
  },
  watch: {
    visible(newValue) {
      if (newValue) {
        this.init()
      }
    },
    checkUserIds: {
      handler(val) {
        if (val.length > 0) {
          const { length, total } = this._statUserCheck()
          this.checked = total > 0 && length === total
          this.isIndeterminate = length > 0 && length < total
        } else {
          this.isIndeterminate = false
          this.checked = false
        }
      },
      deep: true,
      immediate: true
    },
    users: {
      handler(val) {
        if (this.checkUserIds.length > 0) {
          const { length, total } = this._statUserCheck()
          this.checked = total > 0 && length === total
          this.isIndeterminate = length > 0 && length < total
        } else {
          this.isIndeterminate = false
          this.checked = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {},
  methods: {
    _statUserCheck() {
      let length = 0
      this.users.forEach(e => {
        this.checkUserIds.includes(e.userId) && length++
        if (e.qwRelationList && e.qwRelationList.length) {
          e.qwRelationList.forEach(sub => {
            this.checkUserIds.includes(this.getQwSubId(e, sub)) && length++
          })
        }
      })
      const total = this.users.reduce((pre, next) => {
        pre += 1
        if (next.qwRelationList && next.qwRelationList.length) {
          pre += next.qwRelationList.length
        }
        return pre
      }, 0)
      return { length, total }
    },
    getQwSubId(main, sub) {
      return `qw|${main.userId}|${sub.qwUserId || sub.userId || sub.id || ''}`
    },
    _findMainByQwSub(item) {
      const uid = String(item.userId || '')
      const qwUserId =
        item.qwUserId ||
        (item._qwNickName ? item._qwNickName : '')
      // 1. 直接按 userId 开头是 qw| 解析
      if (uid.startsWith('qw|')) {
        const parts = uid.split('|')
        if (parts.length >= 3) {
          const mainKey = parts[1]
          const qwId = parts.slice(2).join('|')
          const main =
            this.users.find(u => String(u.userId) === String(mainKey)) ||
            null
          const sub =
            main && main.qwRelationList
              ? main.qwRelationList.find(
                  s =>
                    String(s.qwUserId || s.userId || s.id || '') ===
                      String(qwId) ||
                    String(s.nickName || s.name || '') ===
                      String(item.nickName || item.name || item._qwNickName)
                )
              : null
          return { main, sub }
        }
      }
      // 2. 全局扫描 qwRelationList，按 nickName 或 qwUserId 反查
      for (const u of this.users) {
        if (u.qwRelationList && Array.isArray(u.qwRelationList)) {
          for (const s of u.qwRelationList) {
            const nameMatch =
              String(s.nickName || s.name || '') ===
                String(item.nickName || item.name || item._qwNickName)
            const qwMatch =
              (qwUserId &&
                String(s.qwUserId || s.userId || s.id || '') ===
                  String(qwUserId)) ||
              (uid &&
                String(s.qwUserId || s.userId || s.id || '') === uid)
            if (nameMatch || qwMatch) {
              return { main: u, sub: s }
            }
          }
        }
      }
      // 3. defaultCheckUser 里如果带 _mainUserId，用它兜底
      if (item._mainUserId) {
        const main =
          this.users.find(u => String(u.userId) === String(item._mainUserId)) ||
          null
        const sub =
          main && main.qwRelationList
            ? main.qwRelationList.find(
                s =>
                  String(s.nickName || s.name || '') ===
                    String(item.nickName || item.name || item._qwNickName) ||
                  String(s.qwUserId || s.userId || s.id || '') ===
                    String(item.qwUserId || '')
              )
            : null
        return { main, sub }
      }
      return { main: null, sub: null }
    },
    _normalizeCheckItem(item) {
      const isQwByFlag = !!item._isQwSub
      const uid = String(item.userId || '')
      const { main, sub } = this._findMainByQwSub(item)
      const realIsQw = isQwByFlag || !!(main && sub)
      if (realIsQw && main && sub) {
        const normalizedRow = this.getQwSubRow(main, sub)
        // 保留用户原始 userId（它是父层回传的真实 ID，不能改）
        normalizedRow.userId = item.userId || normalizedRow.userId
        normalizedRow.id = normalizedRow.userId
        normalizedRow.nickName =
          item.nickName || normalizedRow.nickName || sub.nickName
        normalizedRow.name = item.name || normalizedRow.name || sub.nickName
        normalizedRow._qwNickName =
          item._qwNickName ||
          normalizedRow._qwNickName ||
          sub.nickName
        return {
          isQwSub: true,
          mainKey: String(main.userId),
          mainRow: main,
          subRow: sub,
          normalizedRow
        }
      }
      if (realIsQw && isQwByFlag && !main) {
        // 暂未找到真实主数据（users 还没加载），先用旧字段兜底
        const mainKey = String(item._mainUserId || item.userId)
        return {
          isQwSub: true,
          mainKey,
          mainRow: null,
          subRow: null,
          normalizedRow: item
        }
      }
      return {
        isQwSub: false,
        mainKey: String(item.userId),
        mainRow: item,
        subRow: null,
        normalizedRow: item
      }
    },
    getQwSubRow(main, sub) {
      const id = this.getQwSubId(main, sub)
      return {
        userId: id,
        id,
        qwUserId: sub.qwUserId,
        nickName: sub.nickName || sub.name,
        name: sub.nickName || sub.name,
        avatar: sub.avatar || '',
        phoneNumber: sub.phoneNumber || main.phoneNumber,
        deptName: main.deptName || '',
        corpName: main.corpName || main.deptName || '',
        _isQwSub: true,
        _mainUserId: String(main.userId),
        _mainName: main.nickName || main.name,
        _qwNickName: sub.nickName || sub.name,
        _main: main,
        _sub: sub,
        status: main.status || 0
      }
    },
    isQwSubChecked(main, sub) {
      return this.checkUserIds.includes(this.getQwSubId(main, sub))
    },
    handleToggleQwSub(main, sub) {
      if (this.isUserDisabled(main)) return
      const subId = this.getQwSubId(main, sub)
      if (this.disabledUser.includes(subId)) return
      const row = this.getQwSubRow(main, sub)
      this.changeUser(row)
      this._syncMainBySubs(main)
    },
    delMainGroup(group) {
      const rm = new Set()
      this.checkUser.forEach(u => {
        if (u._isQwSub && String(u._mainUserId) === String(group.mainKey))
          rm.add(String(u.userId))
        if (!u._isQwSub && String(u.userId) === String(group.mainKey))
          rm.add(String(u.userId))
      })
      this.checkUser = this.checkUser.filter(u => !rm.has(String(u.userId)))
      this.checkUserIds = this.checkUserIds.filter(id => !rm.has(String(id)))
    },
    getCheckUserIndex(row) {
      return this.checkUser.findIndex(v => v.userId === row.userId)
    },
    hasQwRelation(main) {
      return !!(
        main &&
        main.qwRelationList &&
        Array.isArray(main.qwRelationList) &&
        main.qwRelationList.length > 0
      )
    },
    isUnboundUser(item) {
      return (
        this.taskObjective &&
        !item?._isQwSub &&
        !this.hasQwRelation(item)
      )
    },
    isUserDisabled(item) {
      return this.disabledUser?.includes(item?.userId) || this.isUnboundUser(item)
    },
    _syncMainBySubs(main) {
      if (!this.multiple || !this.hasQwRelation(main)) return
      const allChecked = main.qwRelationList.every(sub => this.isQwSubChecked(main, sub))
      const anyChecked = main.qwRelationList.some(sub => this.isQwSubChecked(main, sub))
      const mainChecked = this.checkUserIds.includes(main.userId)
      if (allChecked && !mainChecked) {
        this.changeUser(main)
      } else if (!anyChecked && mainChecked) {
        this.changeUser(main)
      } else if (!allChecked && anyChecked && mainChecked) {
        // 子选了部分但不全，主账号保持选中
      }
    },
    _syncSubsByMain(main, willChecked) {
      if (!this.hasQwRelation(main)) return
      if (willChecked) {
        main.qwRelationList.forEach(sub => {
          const subId = this.getQwSubId(main, sub)
          if (
            !this.disabledUser.includes(subId) &&
            !this.isUserDisabled(main) &&
            !this.isQwSubChecked(main, sub)
          ) {
            const subRow = this.getQwSubRow(main, sub)
            const isOverflow =
              this.maxlength !== 0 &&
              this.checkUserIds.length >= this.maxlength
            if (!isOverflow) {
              if (!this.checkUserIds.includes(subRow.userId)) {
                this.checkUser.push(subRow)
                this.checkUserIds.push(subRow.userId)
              }
            }
          }
        })
      } else {
        main.qwRelationList.forEach(sub => {
          const subRow = this.getQwSubRow(main, sub)
          const i = this.checkUser.findIndex(u => u.userId === subRow.userId)
          if (i > -1) this.checkUser.splice(i, 1)
          const j = this.checkUserIds.findIndex(u => u === subRow.userId)
          if (j > -1) this.checkUserIds.splice(j, 1)
        })
      }
    },
    handleSearch() {
      if (this.search === '') {
        this.parentId = this.rootParentId
        this.crumbs = [{ id: this.rootParentId, name: '通讯录', tenantId: this.rootTenantId }]
        this.search = ''
        this.currentPage = 1
        this.tenantId = this.rootTenantId
        this.isSearch = false
        this.users = []
        this.dept = []
        this.getOrgTree()
      } else {
        this.currentPage = 1
        this.tenantId = this.rootTenantId
        this.isSearch = true
        this.crumbs = [{ id: this.rootParentId, name: '通讯录', tenantId: this.rootTenantId }]
        this.getOrgTree()
      }
    },
    init() {
      this.parentId = this.rootParentId
      this.tenantId = this.rootTenantId
      this.crumbs = [{ id: this.rootParentId, name: '通讯录', tenantId: this.rootTenantId }]
      this.search = ''
      this.currentPage = 1
      this.select = 'nickName'
      this.checkDept = JSON.parse(JSON.stringify(this.defaultCheckDept))
      this.checkUser = JSON.parse(JSON.stringify(this.defaultCheckUser)).map(
        u => ({
          ...u,
          _mainUserId: u._mainUserId || String(u.userId),
          _qwNickName: u._qwNickName || u.nickName || u.name,
          _mainName:
            u._mainName ||
            (u._isQwSub ? '' : u.nickName || u.name || '')
        })
      )
      this.checkDeptIds = []
      this.checkDept.map(v => {
        this.checkDeptIds.push(v.deptId)
      })
      this.checkUserIds = []
      this.checkUser.map(v => {
        this.checkUserIds.push(v.userId)
      })
      this.users = []
      this.dept = []
      this.getOrgTree()
    },
    _rehydrateCheckUserByUsers() {
      const next = []
      const nextKeys = new Set()
      this.checkUser.forEach(item => {
        const info = this._normalizeCheckItem(item)
        const row = info.normalizedRow
        let dedupKey
        if (info.isQwSub && info.mainRow && info.subRow) {
          dedupKey = this.getQwSubId(info.mainRow, info.subRow)
        } else if (info.isQwSub) {
          if (row.userId && /^qw\|/.test(String(row.userId))) {
            dedupKey = String(row.userId)
          } else if (info.mainKey && (row.qwUserId || row._qwNickName)) {
            dedupKey = `qw|${info.mainKey}|${row.qwUserId || row._qwNickName || ''}`
          } else {
            dedupKey = String(row.userId)
          }
        } else {
          dedupKey = String(row.userId)
        }
        if (!nextKeys.has(dedupKey)) {
          nextKeys.add(dedupKey)
          next.push(row)
          if (info.isQwSub && !row._isQwSub) {
            row._isQwSub = true
            row._mainUserId = info.mainKey
            row._main = info.mainRow
          }
        }
      })
      this.checkUser = next
      this.checkUserIds = this.checkUser.map(u => u.userId)
    },
    async getOrgTree() {
      this.loading = true
      let deptName = ''
      if (this.type.includes(0) && this.type.length === 1) {
        deptName = this.search
      }
      const deptTreeParams = {
        parentId: '',
        deptName,
        tenantId: this.tenantId
      }
      if (this.isSearch) {
        deptTreeParams.parentId = undefined
      } else if (
        this.tenantId &&
        String(this.parentId) === String(this.rootParentId)
      ) {
        deptTreeParams.deptId = this.rootParentId
      } else {
        deptTreeParams.parentId = this.parentId
      }
      const userPageParams = {
        deptId: this.searchType === 1 ? this.parentId : undefined,
        deptIds: this.searchType === 1 ? undefined : this.parentId,
        returnQwRelation: this.taskObjective,
        tenantId: this.tenantId,
        [this.select]: this.search
      }
      try {
        if (
          (this.type.includes(0) && this.type.length === 1) ||
          this.search === ''
        ) {
          const res1 = this.tenantId
            ? await deptTreeNew(deptTreeParams)
            : await deptTree(deptTreeParams)
          if (res1.data) {
            res1.data.map(v => {
              v.deptId = v.id
              v.name = v.label
            })
            this.depts = res1.data
          }
        } else {
          this.depts = []
        }

        if (this.type.includes(1)) {
          const res2 = this.tenantId
            ? await userNoPageNew(userPageParams)
            : await userNoPage(userPageParams)
          if (String(this.parentId) !== '0' || this.tenantId) {
            if (res2.data) {
              const ifAll = this.ifAll
              this.users = res2.data.reduce((pre, next) => {
                if (ifAll) {
                  pre.push({ ...next, name: next.userName })
                } else {
                  next.status !== 1 &&
                    pre.push({ ...next, name: next.userName })
                }
                return pre
              }, [])
              this.noMore = true
            }
          }
          this._rehydrateCheckUserByUsers()
        }
        this.loading = false
      } catch (err) {
        this.noMore = true
        this.loading = false
        this.depts = []
        this.users = []
        this.total = 0
      }
    },
    cancel() {
      this.visible = false
    },
    sure() {
      const length = this.checkUser.length + this.checkDept.length
      if (length < this.minlength) {
        return this.$message.error(`至少需要选择${this.minlength}项`)
      }
      if (
        this.isShowSelect &&
        !this.qwInheritType &&
        this.qwInheritType !== 0
      ) {
        return this.$message.error(`请选择企业微信继承状态!`)
      }
      this.visible = false
      if (this.success) {
        const objData = this.isShowSelect
          ? {
              dept: this.checkDept,
              user: this.checkUser,
              qwInheritType: this.qwInheritType
            }
          : {
              dept: this.checkDept,
              user: this.checkUser
            }
        this.success(objData)
      }
    },
    goToNext(row) {
      this.parentId = row.deptId
      this.tenantId = row.tenantId
      this.currentPage = 1
      this.isSearch = false
      this.crumbs.push(row)
      this.getOrgTree()
    },
    changeUser(row) {
      if (this.disabledUser?.includes(row?.userId)) return
      if (this.isUnboundUser(row)) {
        return this.$message.error('\u8be5\u7528\u6237\u6ca1\u6709\u7ed1\u5b9a\u63a5\u91cf\u4f01\u5fae')
      }

      if (this.multiple) {
        const addOverflow =
          this.maxlength !== 0 &&
          this.checkUserIds.length >= this.maxlength &&
          !this.checkUserIds.includes(row.userId)
        if (addOverflow) {
          return this.$message.error(`最多只能选择${this.maxlength}项`)
        }

        const wasChecked = this.checkUserIds.includes(row.userId)
        if (wasChecked) {
          const index = this.checkUser.findIndex(v => v.userId === row.userId)
          this.checkUser.splice(index, 1)
          const i = this.checkUserIds.findIndex(v => v === row.userId)
          this.checkUserIds.splice(i, 1)
        } else {
          this.checkUser.push(row)
          this.checkUserIds.push(row.userId)
        }
        const willChecked = !wasChecked
        if (!row._isQwSub) {
          this._syncSubsByMain(row, willChecked)
        }
        if (row._isQwSub && row._main) {
          this._syncMainBySubs(row._main)
        }
      } else {
        // 单选：点主账号时默认选中第一个企微账号，避免自动勾选所有子账号
        const firstQw = !row._isQwSub && row.qwRelationList?.length
          ? row.qwRelationList[0]
          : null
        const willRow = firstQw ? this.getQwSubRow(row, firstQw) : row
        const wasChecked = this.checkUserIds.includes(willRow.userId)
        this.checkUser = []
        this.checkUserIds = []
        if (!wasChecked) {
          this.checkUser.push(willRow)
          this.checkUserIds = this.checkUser.map(v => v.userId)
        }
      }
    },
    changeDept(row) {
      if (this.disabledDept?.includes(row?.deptId) || row.status === 1) return
      if (this.multiple) {
        if (this.checkDeptIds.includes(row.deptId)) {
          const index = this.checkDept.findIndex(v => v.deptId === row.deptId)
          this.checkDept.splice(index, 1)
          const i = this.checkDeptIds.findIndex(v => v === row.deptId)
          this.checkDeptIds.splice(i, 1)
        } else {
          this.checkDept.push(row)
          this.checkDeptIds.push(row.deptId)
        }
      } else {
        this.checkDept = []
        this.checkDeptIds = []
        if (!this.checkDeptIds.includes(row.deptId)) {
          this.checkDept.push(row)
          this.checkDeptIds.push(row.deptId)
        }
      }
    },
    changeCrumbs(row, index) {
      if (index === this.crumbs.length - 1) {
        return
      }
      const i = this.crumbs.findIndex(v => v.id === row.id)
      this.crumbs.splice(i + 1, this.crumbs.length - 1)
      if (row.id === '-1') {
        this.parentId = ''
        this.tenantId = ''
      } else {
        this.parentId = row.id
        this.tenantId = row.tenantId
      }
      this.currentPage = 1
      this.users = []
      this.depts = []
      this.getOrgTree()
    },
    handleCurrentChange(row) {
      this.currentPage = row
      this.getOrgTree()
    },
    load() {
      this.currentPage = this.currentPage + 1
      this.getOrgTree()
    },
    delUserCheck(row, index) {
      if (this.disabledUser.includes(row.userId)) {
        return this.$message.error('该人员不允许删除~')
      }
      const idx =
        index > -1
          ? index
          : this.checkUser.findIndex(v => v.userId === row.userId)
      if (idx > -1) {
        this.checkUser.splice(idx, 1)
        const i = this.checkUserIds.findIndex(v => v === row.userId)
        if (i > -1) this.checkUserIds.splice(i, 1)
        if (row._isQwSub && row._main) {
          this._syncMainBySubs(row._main)
        }
      }
    },
    delDeptCheck(row, index) {
      this.checkDept.splice(index, 1)
      this.checkDeptIds.splice(index, 1)
    },
    handleCheckAllChange(val) {
      if (!this.checked) {
        if (this.maxlength > 0) {
          const selectArr = []
          this.users.forEach(e => {
            if (!this.checkUserIds.includes(e.userId)) {
              selectArr.push(e)
            }
            if (e.qwRelationList && e.qwRelationList.length) {
              e.qwRelationList.forEach(sub => {
                if (!this.checkUserIds.includes(this.getQwSubId(e, sub))) {
                  selectArr.push(this.getQwSubRow(e, sub))
                }
              })
            }
          })
          if (selectArr.length + this.checkUserIds.length > this.maxlength) {
            this.checked = false
            return this.$message.error(
              `人员最多不可超过${this.maxlength}个，请重新选择！`
            )
          } else {
            this.users.forEach(e => {
              if (!this.checkUserIds.includes(e.userId)) {
                this.checkUserIds.push(e.userId)
                this.checkUser.push(e)
              }
              if (e.qwRelationList && e.qwRelationList.length) {
                e.qwRelationList.forEach(sub => {
                  if (!this.checkUserIds.includes(this.getQwSubId(e, sub))) {
                    const subRow = this.getQwSubRow(e, sub)
                    this.checkUserIds.push(subRow.userId)
                    this.checkUser.push(subRow)
                  }
                })
              }
            })
            this.checked = true
          }
        } else {
          this.users.forEach(e => {
            if (!this.checkUserIds.includes(e.userId)) {
              this.checkUserIds.push(e.userId)
              this.checkUser.push(e)
            }
            if (e.qwRelationList && e.qwRelationList.length) {
              e.qwRelationList.forEach(sub => {
                if (!this.checkUserIds.includes(this.getQwSubId(e, sub))) {
                  const subRow = this.getQwSubRow(e, sub)
                  this.checkUserIds.push(subRow.userId)
                  this.checkUser.push(subRow)
                }
              })
            }
          })
          this.isIndeterminate = false
        }
      } else {
        this.isIndeterminate = false
        const rm = new Set()
        this.users.forEach(e => {
          rm.add(String(e.userId))
          if (e.qwRelationList && e.qwRelationList.length) {
            e.qwRelationList.forEach(sub => {
              rm.add(this.getQwSubId(e, sub))
            })
          }
        })
        this.checkUser = this.checkUser.filter(
          u => !rm.has(String(u.userId))
        )
        this.checkUserIds = this.checkUserIds.filter(
          id => !rm.has(String(id))
        )
      }
    },
    ifCanCheck() {
      const length = this.users.reduce((pre, next) => {
        this.disabledUser.includes(next.userId) && pre++
        return pre
      }, 0)
      return this.multiple && this.type.includes(1) && length === 0
    }
  }
}
</script>
<style lang="scss" scoped>
.address {
  .address_book {
    display: flex;
    width: 100%;
    height: 450px;
    .address_book_left {
      flex: 1;
      display: flex;
      flex-direction: column;
      border: 1px solid #eee;
      .address_book_left_search {
        padding-top: 16px;
        margin-left: 16px;
        margin-right: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .input-with-select {
        width: 100%;
      }
      .address_book_left_tree {
        width: 350px;
        overflow: auto;
      }
      .crumbs {
        width: 100%;
        margin: 10px 16px;
        .crumbsView {
          margin: 10px 0;
          cursor: pointer;
        }
        .colorBlue {
          color: #409eff;
        }
      }
      .addressBooks {
        &::-webkit-scrollbar {
          width: 4px;
          height: 10px;
          background-color: transparent;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 6px;
          background-color: rgba(0, 0, 0, 0.2);
          transition: all 0.4s ease;
        }
        &::-webkit-scrollbar-track {
          background-color: rgba(0, 0, 0, 0.1);
        }
      }
      .qw-relations {
        display: flex;
        flex-direction: column;
        gap: 6px;
        padding: 0 14px 10px 36px;
        .qw-relation-card {
          display: flex;
          align-items: center;
          padding: 8px 10px;
          background: #fff;
          border: 1px solid #e4e7ed;
          border-radius: 6px;
          cursor: pointer;
          transition: all 0.2s;
          .qw-relation-info {
            flex: 1;
            min-width: 0;
            .qw-relation-name {
              font-size: 14px;
              color: #1f2329;
              line-height: 20px;
            }
            .qw-relation-dept {
              margin-top: 4px;
              padding: 0 6px;
              font-size: 12px;
              line-height: 20px;
              color: #86909c;
              background: #f2f3f5;
              border-radius: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
          &:hover {
            border-color: #c9cdd4;
          }
          &--active {
            border-color: #165dff;
            background: rgba(22, 93, 255, 0.05);
            box-shadow: 0 0 0 1px #165dff inset;
          }
        }
      }
    }
    .address_book_right {
      flex: 1;
      overflow: auto;
      border: 1px solid #eee;
      &::-webkit-scrollbar {
        width: 4px;
        height: 10px;
        background-color: transparent;
      }
      &::-webkit-scrollbar-thumb {
        border-radius: 6px;
        background-color: rgba(0, 0, 0, 0.2);
        transition: all 0.4s ease;
      }
      &::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 0.1);
      }
      .check-group {
        margin: 6px 0;
        .check-group__main {
          font-weight: 600;
          padding: 6px 10px;
          &-label {
            color: #1f2329;
          }
        }
        .check-group__sub {
          padding-left: 26px;
          font-weight: 400;
          &-label {
            .qw-prefix {
              color: #165dff;
              margin-right: 8px;
            }
            .qw-name {
              color: #4e5969;
            }
          }
        }
      }
      .checkList {
        line-height: 30px;
        display: flex;
        align-items: center;
        width: 100%;
        justify-content: space-between;
        padding: 0 8px;
        .el-icon-close {
          cursor: pointer;
        }
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }
  .address_footer {
    margin-top: 10px;
    display: flex;
    > div {
      flex: 1;
    }
    .inherit_select {
      display: flex;
      align-items: center;
      > div:nth-of-type(1) {
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        text-align: center;
        font-style: normal;
        margin-right: 5px;
        &::before {
          content: '*';
          color: red;
          margin-right: 3px;
        }
      }
    }
    .footer_btn {
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }

  .addressBooks {
    overflow: auto;
    .addressBooksBox {
      padding: 10px 10px;
      display: flex;
      align-items: center;
      &:hover {
        background: #f5f7fa;
      }
      .checkBox {
        margin-right: 10px;
        width: 16px;
        height: 16px;
        border: 1px solid #dcdfe6;
        border-radius: 2px;
      }
      .checkBoxRadio {
        margin-right: 10px;
        width: 16px;
        height: 16px;
        border: 1px solid #dcdfe6;
        border-radius: 50%;
      }
      .checkName {
        flex: 1;
        display: flex;
        .userName {
          max-width: 140px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .next {
        border-left: 1px solid #dcdfe6;
        padding-left: 10px;
        cursor: pointer;
      }
    }
  }
  .m-r-5 {
    margin-right: 5px;
  }
  .m-l-10 {
    margin-left: 10px;
  }
}

.noData {
  font-size: 14px;
  line-height: 100px;
  height: 100px;
  text-align: center;
  color: #c0c4cc;
}
.disabled {
  background-color: #f2f6fc !important;
  border-color: #dcdfe6 !important;
  cursor: not-allowed !important;
}
</style>
